import { ArticleCategoryScreen } from 'app/features/blog/screens'
import { articleCategoryQuery, categoryArticlesQuery } from 'app/features/blog/screens/article-category-screen/queries'
import { addApolloState, initializeApollo } from 'lib/initialize-apollo'
import { withAuthedPage } from 'lib/session'
import { GetServerSideProps } from 'next'

export default function Page() {
  return <ArticleCategoryScreen />
}

export const getServerSideProps: GetServerSideProps = withAuthedPage(async ({ req, res, query }) => {
  const user = req?.session?.user

  if (!query.slug) {
    return {
      notFound: true,
    }
  }

  const client = initializeApollo({ token: user?.token })

  await client.query({
    query: articleCategoryQuery.query,
    variables: {
      slug: query.slug as string,
    },
  })
  await client.query({
    query: categoryArticlesQuery.query,
    variables: {
      slug: query.slug as string,
      ...categoryArticlesQuery.defaultVariables,
    },
  })

  // add cache headers if not authenticated
  if (!user) {
    res.setHeader('Cache-Control', 's-maxage=60, stale-while-revalidate')
  }

  return addApolloState(client, {
    props: {
      user: user || null,
    },
  })
})
